// ===== Credits: menu music and thanks. Edit here when the menu track is replaced. =====
// A world's music is in that world's meta.credits (src/worlds/<key>/world.ts).
// file = the name in audio/music/, id = the Pixabay number (it is in the downloaded file's name)
export const CREDITS = {
  menu: { file: 'menu.mp3', title: 'Children Treasures', artist: 'SergeQuadrado', id: 122521, url: 'https://pixabay.com/music/lullabies-children-treasures-122521/' },
  thanks: ['Pixabay', 'Kenney (kenney.nl)', 'Sonniss', 'Matter.js'],
};
